import { memo, PropsWithChildren, useEffect, useMemo, useState } from "react";
import { Tooltip as ReactTooltip, PlacesType } from "react-tooltip";

import classes from "./Tooltip.module.css";

type Props = PropsWithChildren<{
  content: string;
  id?: string;
  place?: PlacesType;
  disabled?: boolean;
}>;

export const Tooltip = memo(({
  children,
  content,
  id,
  place = "bottom",
  disabled = false,
}: Props) => {
  const tooltipId = useMemo(
    () => id || `tooltip-${Math.random().toString(36).substring(2, 9)}`,
    [id]
  );
  const [portalRoot, setPortalRoot] = useState<Element | null>(null);

  useEffect(() => {
    setPortalRoot(document.body);
  }, []);

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <>
      <div data-tooltip-id={tooltipId}>
        {children}
      </div>
      
      <ReactTooltip
        id={tooltipId}
        content={content}
        place={place}
        className={classes.tooltip}
        positionStrategy="fixed"
        portalRoot={portalRoot}
      />
    </>
  );
});

Tooltip.displayName = "Tooltip";